import styles from "./Auth.module.scss";
import { IAuthError } from "./types";
import license from "@/components/AuthComponents/License/License";
import LicenseAlertsModal from "@/components/BaseComponents/Popups/LicenseAlert/Modal";
import { useLazyGetStatusQuery } from "@/core/api/license/license";
import { useLazyGetUserInfoQuery } from "@/core/api/user/user";
import { useLicenseStore } from "@/core/store/LicenseStore";
import { useUserStore } from "@/core/store/UserDataStore";
import { snackbarForbidden } from "@/services/snackbar.service";
import { Button, Input, InputPassword, useSnackbars } from "@aurora/components";
import cx from "classnames";
import { ICONS } from "components/BaseComponents/Icons";
import { usePostLoginMutation } from "core/api/oauth2";
import { store } from "core/store";
import {
  setAuth,
  setLoading,
  useAuthStore,
} from "core/store/reducers/AuthSlice";
import React, { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Auth: FC = () => {
  const navigate = useNavigate();
  const [username, changeUsername] = useState("");
  const [password, changePassword] = useState("");
  const [licenseExpired, setLicenseExpired] = useState(false);

  const [
    auth,
    { data: loginData, error: loginError, isLoading: isLoginLoading },
  ] = usePostLoginMutation();
  const [licenseStatus, { data: licenseData, error: licenseError }] =
    useLazyGetStatusQuery();
  const [getUserInfo, { data: userInfoData, error: userInfoError }] =
    useLazyGetUserInfoQuery();

  const licenseStore = useLicenseStore();
  const { setIsManagerOrWatcher, setUser } = useUserStore();
  const { login } = useAuthStore();

  const { snackbarInfo } = useSnackbars();

  const isDisabled = !(username && password) || isLoginLoading;

  const [authError, setAuthError] = useState<IAuthError>({
    description: "",
    status: "success",
  });

  const hiddenError = () => {
    setAuthError({
      description: "",
      status: "success",
    });
  };

  // отображение ошибки в консоли
  useEffect(() => {
    if (loginError && "data" in loginError) {
      setAuthError({
        description: loginError.data.message
          ? loginError.data.message
          : "Сервис временно недоступен",
        status: "error",
      });
    }
    if (
      (loginError && "data" in loginError) ||
      (userInfoError && "data" in userInfoError)
    ) {
      setAuthError({
        description: "Сервис временно недоступен",
        status: "error",
      });
    }
  }, [loginError, licenseError, userInfoError]);

  useEffect(() => {
    if (loginData && licenseData && userInfoData) {
      licenseStore.setLicense(licenseData);
      setUser(userInfoData);
      setIsManagerOrWatcher(
        userInfoData.category === "MANAGER" ||
          userInfoData.category === "WATCHER",
      );
      login(
        loginData.accessToken,
        userInfoData.category ?? null,
        loginData.roles,
      );

      const license = licenseData.license;
      const validTo =
        license && license.validTo ? Date.parse(license.validTo) : null;
      const isExpired = !license || (validTo && validTo < Date.now());

      if (isExpired && userInfoData.category !== "ADMIN") {
        setLicenseExpired(true);
        return; // прерываем дальнейшую авторизацию
      } //else {
      //   store.dispatch(
      //     setAuth(!isExpired || userInfoData.category === "ADMIN"),
      //   );
      // }
      navigate("/vacancies");
    }
  }, [loginData, licenseData, userInfoData]);

  const handleSubmit = async (e?: any) => {
    e?.preventDefault();
    try {
      await auth({
        password,
        username,
      });
      await licenseStatus();
      await getUserInfo();
    } catch (e) {
      console.log("Error", e);
    } finally {
      store.dispatch(setLoading(false));
    }
  };

  return (
    <div className={styles.authContainer}>
      <h1 className={styles.authLogo}>{ICONS.LOGO}</h1>
      <div className={styles.section}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <Input
            label={"Логин"}
            onChange={(e: any) => {
              changeUsername(e.target.value);
            }}
            placeholder={"Введите логин"}
            value={username}
          />
          <InputPassword
            description={authError.description}
            label={"Пароль"}
            onChange={(e: any) => {
              changePassword(e.target.value);
            }}
            onKeyDown={hiddenError}
            placeholder={"Введите пароль"}
            status={authError.status}
            value={password}
          />
          <div className={cx(styles.buttonSection, "mt-8")}>
            <Button
              className={cx(styles.buttonLogin)}
              disabled={isDisabled}
              type="submit"
              variant="primary"
            >
              Войти
            </Button>
          </div>
        </form>
      </div>
      {licenseExpired && (
        <LicenseAlertsModal
          level={"alert"}
          licenseNulled={!licenseData.license}
        />
      )}
    </div>
  );
};
export default Auth;
